export default "__VITE_ASSET__a8sVy_cB__"